import Vue from 'vue'

let healthyApi = true

function dialog (title = '', message = '', type = 'is-danger') {
  Vue.prototype.$dialog.alert({
    title,
    message,
    type
  })
}

export default {
  async getApiVersion ({commit}) {
    const {body} = await Vue.http.get('/')
    commit('setApiVersion', body.data.version)
  },
  async checkHealthApi () {
    try {
      await Vue.http.get('/')

      if (!healthyApi) {
        Vue.prototype.$snackbar.open('Er is weer verbinding gemaakt met de API')
      }

      healthyApi = true
    } catch (error) {
      if (healthyApi) {
        if (process.env.NODE_ENV === 'development') {
          return
        }

        dialog('API Error', 'Het lijkt er op dat de St. Job API offline is. Probeer de pagina te verversen om het probleem te verhelpen. Wanneer dit niet het probleem oplost contact de administrator.')
      }

      healthyApi = false
    }
  },
  async testAccountViewConnection (ctx) {
    try {
      await Vue.http.get('/test/connection/accountview')
    } catch (error) {
      dialog('AccountView Error', 'Het lijkt er op dat er geen verbiding met AccountView gemaakt kan worden. Bepaalde functionaliteiten zullen hierdoor waarschijnlijk niet werken.')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js